import React from 'react';
import '../../styles-wa/UnreadDivider.css';

/**
 * UnreadDivider Component
 * Displays a visual separator between read and unread messages
 * Styled to match WhatsApp's unread divider design
 */
const UnreadDivider = ({ unreadCount = 0 }) => {
    return (
        <div className="unread-divider-container">
            <div className="unread-divider-line" />
            <div className="unread-divider-label">
                {unreadCount > 0 && (
                    <>
                        <span className="unread-divider-text">
                            {unreadCount === 1 ? '1 unread message' : `${unreadCount} unread messages`}
                        </span>
                    </>
                )}
                {unreadCount === 0 && (
                    <span className="unread-divider-text unread-divider-empty">
                        Unread Messages
                    </span>
                )}
            </div>
            <div className="unread-divider-line" />
        </div>
    );
};

export default UnreadDivider;



